import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/common.json';
import ru from './locales/ru/common.json';

export const SUPPORTED_LANGUAGES = ['ru', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { common: ru },
      en: { common: en },
    },
    fallbackLng: 'ru',
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      // The browser's own language is deliberately not consulted. The warehouse
      // is Russian-speaking and the shared workstations in it come with whatever
      // locale they were installed with; letting `navigator` decide meant a fresh
      // profile could open in English for someone who never asked for it. A
      // choice made in the switcher still wins — that is what localStorage holds.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

/**
 * Keep the document in step with the interface.
 *
 * `lang` drives hyphenation and the spell checker; `<title>` is what a browser
 * tab, a bookmark and an installed app's task switcher show. Both used to be
 * frozen at the Russian text baked into index.html.
 */
function describeDocument(language: string): void {
  document.documentElement.lang = language;
  const title = i18n.t('app.name');
  if (title) document.title = title;
}

i18n.on('languageChanged', describeDocument);
i18n.on('initialized', () => describeDocument(i18n.resolvedLanguage ?? 'ru'));

export default i18n;
